import { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useLocation } from 'react-router-dom';

const useAnalyticsContainer = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize('UA-237995350-2');
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);
};

export default useAnalyticsContainer;
